import useTestId from '@ori/testid-generator';
import { TOP_BANNER } from "./constants";
import { Root } from "./styles";
import { TopBannerBreadcrumbs } from "./TopBannerBreadcrumbs";
import { TopBannerImage } from "./TopBannerImage";
import { TopBannerTitle } from "./TopBannerTitle";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Component for displaying content on top of a page. It contains some background, title and breadcrumbs.
 * Must have specified at least `backgroundColor` or `imageUrl` or `title` or `breadcrumbs. Otherwise component returns `null`.
 */
export var TopBanner = function TopBanner(_ref) {
  var backgroundColor = _ref.backgroundColor,
    breadcrumbs = _ref.breadcrumbs,
    className = _ref.className,
    imageUrl = _ref.imageUrl,
    textColor = _ref.textColor,
    title = _ref.title;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  if (!backgroundColor && !imageUrl && !title) {
    return /*#__PURE__*/_jsx(TopBannerBreadcrumbs, {
      breadcrumbs: breadcrumbs
    });
  }
  return /*#__PURE__*/_jsxs(Root, {
    backgroundColor: backgroundColor,
    className: className,
    "data-testid": getTestId(TOP_BANNER),
    textColor: textColor,
    children: [/*#__PURE__*/_jsx(TopBannerBreadcrumbs, {
      breadcrumbs: breadcrumbs
    }), /*#__PURE__*/_jsx(TopBannerTitle, {
      title: title
    }), /*#__PURE__*/_jsx(TopBannerImage, {
      backgroundColor: backgroundColor,
      imageUrl: imageUrl,
      title: title
    })]
  });
};
//# sourceMappingURL=TopBanner.js.map